var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwoUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.22604 14.0745C12.6087 14.0745 15.4999 14.587 15.4999 16.6346C15.4999 18.6822 12.628 19.2095 9.22604 19.2095C5.84243 19.2095 2.95215 18.7015 2.95215 16.653C2.95215 14.6045 5.82318 14.0745 9.22604 14.0745Z",
    stroke: "#12499C",
    strokeWidth: 1.65054,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.22592 11.1519C7.00503 11.1519 5.2041 9.35191 5.2041 7.13101C5.2041 4.91012 7.00503 3.11011 9.22592 3.11011C11.4459 3.11011 13.2468 4.91012 13.2468 7.13101C13.2551 9.34366 11.467 11.1437 9.25435 11.1519H9.22592Z",
    stroke: "#12499C",
    strokeWidth: 1.65054,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5449 10.1084C17.013 9.90207 18.1436 8.64216 18.1464 7.11724C18.1464 5.61433 17.0506 4.36725 15.6137 4.13159",
    stroke: "#12499C",
    strokeWidth: 1.65054,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4824 13.6394C18.9046 13.8512 19.8977 14.3501 19.8977 15.3771C19.8977 16.084 19.4301 16.5425 18.6745 16.8295",
    stroke: "#12499C",
    strokeWidth: 1.65054,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwoUser);
export default __webpack_public_path__ + "static/media/Two-User.f5ffdd81b962a818046f717c94afcb55.svg";
export { ForwardRef as ReactComponent };